import { inject, Injectable } from '@angular/core';
import { PersonalDataDto } from '../types';
import { StaticStorage } from '../static-storage';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { httpRetry } from '$core/helpers/http-retry';

@Injectable({
  providedIn: 'root',
})
export class PersonalService {
  private readonly http = inject(HttpClient);
  private readonly staticStorage = inject(StaticStorage);

  public getPersonalStatics(): Observable<unknown> {
    return this.http.get<unknown>('/v2/personal-data').pipe(
      httpRetry(5),
      tap((res: PersonalDataDto) => {
        this.staticStorage.updateStatic(res);
      })
    );
  }
}
